import React from 'react'
import { observer } from 'mobx-react'
import Skeleton from 'react-loading-skeleton'
import { withTranslation } from 'react-i18next'

import { getRandomIntInclusive } from '@flowwai-frontend/shared/utils/common'

import { WithTranslation } from '../../../types'

import { REACT_LOADING_DURATION } from '../../Loader/constants'

import {
   TaskLoadingWrapper,
   HomeBoardLoadingWrapper,
   AssigneeAndIdLoadingWrapper,
   Header,
   ContentLoader
} from './styledComponents'
interface HomeBoardLoaderProps extends WithTranslation {}
class HomeBoardLoader extends React.Component<HomeBoardLoaderProps> {
   numberOfHomeTasks = 20
   numberOfDataRows = 3
   render() {
      return (
         <HomeBoardLoadingWrapper>
            {Array.from(Array(this.numberOfHomeTasks).keys()).map(index => (
               <TaskLoadingWrapper key={index}>
                  <Header />
                  <ContentLoader>
                     {Array.from(Array(this.numberOfDataRows).keys()).map(
                        index => (
                           <Skeleton
                              key={index}
                              duration={REACT_LOADING_DURATION}
                              width={getRandomIntInclusive(100, 200)}
                              height={12}
                              style={{ marginBottom: 4, marginTop: 4 }}
                           />
                        )
                     )}
                     <AssigneeAndIdLoadingWrapper>
                        <Skeleton
                           key={index}
                           duration={REACT_LOADING_DURATION}
                           width={32}
                           height={32}
                           circle={true}
                           style={{ marginBottom: 8, marginTop: 8 }}
                        />
                        <Skeleton
                           key={index}
                           duration={REACT_LOADING_DURATION}
                           width={80}
                           height={16}
                           style={{
                              marginBottom: 8,
                              marginTop: 8,
                              borderRadius: 4
                           }}
                        />
                     </AssigneeAndIdLoadingWrapper>
                  </ContentLoader>
               </TaskLoadingWrapper>
            ))}
         </HomeBoardLoadingWrapper>
      )
   }
}

export default withTranslation()(observer(HomeBoardLoader))
